<div class="absolute left-1/2 -translate-x-1/2 transform top-40 text-white">
  <p class="font-bold text-[44px]">Formular eingesendet</p>
  <p>Vielen Dank! Wir melden uns in Kürze bei Ihnen</p>
</div>